export const countryCodes: Record<string, { name: string; flag: string }> = {
  "001": { name: "United States", flag: "🇺🇸" },
  "007": { name: "Russia", flag: "🇷🇺" },
  "020": { name: "Egypt", flag: "🇪🇬" },
  "027": { name: "South Africa", flag: "🇿🇦" },
  "030": { name: "Greece", flag: "🇬🇷" },
  "031": { name: "Netherlands", flag: "🇳🇱" },
  "032": { name: "Belgium", flag: "🇧🇪" },
  "033": { name: "France", flag: "🇫🇷" },
  "034": { name: "Spain", flag: "🇪🇸" },
  "036": { name: "Hungary", flag: "🇭🇺" },
  "039": { name: "Italy", flag: "🇮🇹" },
  "040": { name: "Romania", flag: "🇷🇴" },
  "041": { name: "Switzerland", flag: "🇨🇭" },
  "043": { name: "Austria", flag: "🇦🇹" },
  "044": { name: "United Kingdom", flag: "🇬🇧" },
  "045": { name: "Denmark", flag: "🇩🇰" },
  "046": { name: "Sweden", flag: "🇸🇪" },
  "047": { name: "Norway", flag: "🇳🇴" },
  "048": { name: "Poland", flag: "🇵🇱" },
  "049": { name: "Germany", flag: "🇩🇪" },
  "051": { name: "Peru", flag: "🇵🇪" },
  "052": { name: "Mexico", flag: "🇲🇽" },
  "053": { name: "Cuba", flag: "🇨🇺" },
  "054": { name: "Argentina", flag: "🇦🇷" },
  "549": { name: "Argentina", flag: "🇦🇷" },
  "055": { name: "Brazil", flag: "🇧🇷" },
  "056": { name: "Chile", flag: "🇨🇱" },
  "057": { name: "Colombia", flag: "🇨🇴" },
  "058": { name: "Venezuela", flag: "🇻🇪" },
  "060": { name: "Malaysia", flag: "🇲🇾" },
  "061": { name: "Australia", flag: "🇦🇺" },
  "062": { name: "Indonesia", flag: "🇮🇩" },
  "063": { name: "Philippines", flag: "🇵🇭" },
  "064": { name: "New Zealand", flag: "🇳🇿" },
  "065": { name: "Singapore", flag: "🇸🇬" },
  "066": { name: "Thailand", flag: "🇹🇭" },
  "081": { name: "Japan", flag: "🇯🇵" },
  "082": { name: "South Korea", flag: "🇰🇷" },
  "084": { name: "Vietnam", flag: "🇻🇳" },
  "086": { name: "China", flag: "🇨🇳" },
  "090": { name: "Turkey", flag: "🇹🇷" },
  "091": { name: "India", flag: "🇮🇳" },
  "092": { name: "Pakistan", flag: "🇵🇰" },
  "093": { name: "Afghanistan", flag: "🇦🇫" },
  "094": { name: "Sri Lanka", flag: "🇱🇰" },
  "095": { name: "Myanmar", flag: "🇲🇲" },
  "098": { name: "Iran", flag: "🇮🇷" },
  "212": { name: "Morocco", flag: "🇲🇦" },
  "213": { name: "Algeria", flag: "🇩🇿" },
  "216": { name: "Tunisia", flag: "🇹🇳" },
  "218": { name: "Libya", flag: "🇱🇾" },
  "220": { name: "Gambia", flag: "🇬🇲" },
  "221": { name: "Senegal", flag: "🇸🇳" },
  "222": { name: "Mauritania", flag: "🇲🇷" },
  "223": { name: "Mali", flag: "🇲🇱" },
  "224": { name: "Guinea", flag: "🇬🇳" },
  "225": { name: "Ivory Coast", flag: "🇨🇮" },
  "226": { name: "Burkina Faso", flag: "🇧🇫" },
  "227": { name: "Niger", flag: "🇳🇪" },
  "228": { name: "Togo", flag: "🇹🇬" },
  "229": { name: "Benin", flag: "🇧🇯" },
  "230": { name: "Mauritius", flag: "🇲🇺" },
  "231": { name: "Liberia", flag: "🇱🇷" },
  "232": { name: "Sierra Leone", flag: "🇸🇱" },
  "233": { name: "Ghana", flag: "🇬🇭" },
  "234": { name: "Nigeria", flag: "🇳🇬" },
  "235": { name: "Chad", flag: "🇹🇩" },
  "236": { name: "Central African Republic", flag: "🇨🇫" },
  "237": { name: "Cameroon", flag: "🇨🇲" },
  "238": { name: "Cape Verde", flag: "🇨🇻" },
  "239": { name: "São Tomé and Príncipe", flag: "🇸🇹" },
  "240": { name: "Equatorial Guinea", flag: "🇬🇶" },
  "241": { name: "Gabon", flag: "🇬🇦" },
  "242": { name: "Republic of the Congo", flag: "🇨🇬" },
  "243": { name: "Democratic Republic of the Congo", flag: "🇨🇩" },
  "244": { name: "Angola", flag: "🇦🇴" },
  "245": { name: "Guinea-Bissau", flag: "🇬🇼" },
  "246": { name: "British Indian Ocean Territory", flag: "🇮🇴" },
  "247": { name: "Ascension Island", flag: "🇸🇭" },
  "248": { name: "Seychelles", flag: "🇸🇨" },
  "249": { name: "Sudan", flag: "🇸🇩" },
  "250": { name: "Rwanda", flag: "🇷🇼" },
  "251": { name: "Ethiopia", flag: "🇪🇹" },
  "252": { name: "Somalia", flag: "🇸🇴" },
  "253": { name: "Djibouti", flag: "🇩🇯" },
  "254": { name: "Kenya", flag: "🇰🇪" },
  "255": { name: "Tanzania", flag: "🇹🇿" },
  "256": { name: "Uganda", flag: "🇺🇬" },
  "257": { name: "Burundi", flag: "🇧🇮" },
  "258": { name: "Mozambique", flag: "🇲🇿" },
  "260": { name: "Zambia", flag: "🇿🇲" },
  "261": { name: "Madagascar", flag: "🇲🇬" },
  "262": { name: "Réunion", flag: "🇷🇪" },
  "263": { name: "Zimbabwe", flag: "🇿🇼" },
  "264": { name: "Namibia", flag: "🇳🇦" },
  "265": { name: "Malawi", flag: "🇲🇼" },
  "266": { name: "Lesotho", flag: "🇱🇸" },
  "267": { name: "Botswana", flag: "🇧🇼" },
  "268": { name: "Eswatini", flag: "🇸🇿" },
  "269": { name: "Comoros", flag: "🇰🇲" },
  "290": { name: "Saint Helena", flag: "🇸🇭" },
  "291": { name: "Eritrea", flag: "🇪🇷" },
  "297": { name: "Aruba", flag: "🇦🇼" },
  "298": { name: "Faroe Islands", flag: "🇫🇴" },
  "299": { name: "Greenland", flag: "🇬🇱" },
  "350": { name: "Gibraltar", flag: "🇬🇮" },
  "351": { name: "Portugal", flag: "🇵🇹" },
  "352": { name: "Luxembourg", flag: "🇱🇺" },
  "353": { name: "Ireland", flag: "🇮🇪" },
  "354": { name: "Iceland", flag: "🇮🇸" },
  "355": { name: "Albania", flag: "🇦🇱" },
  "356": { name: "Malta", flag: "🇲🇹" },
  "357": { name: "Cyprus", flag: "🇨🇾" },
  "358": { name: "Finland", flag: "🇫🇮" },
  "359": { name: "Bulgaria", flag: "🇧🇬" },
  "370": { name: "Lithuania", flag: "🇱🇹" },
  "371": { name: "Latvia", flag: "🇱🇻" },
  "372": { name: "Estonia", flag: "🇪🇪" },
  "373": { name: "Moldova", flag: "🇲🇩" },
  "374": { name: "Armenia", flag: "🇦🇲" },
  "375": { name: "Belarus", flag: "🇧🇾" },
  "376": { name: "Andorra", flag: "🇦🇩" },
  "377": { name: "Monaco", flag: "🇲🇨" },
  "378": { name: "San Marino", flag: "🇸🇲" },
  "380": { name: "Ukraine", flag: "🇺🇦" },
  "381": { name: "Serbia", flag: "🇷🇸" },
  "382": { name: "Montenegro", flag: "🇲🇪" },
  "383": { name: "Kosovo", flag: "🇽🇰" },
  "385": { name: "Croatia", flag: "🇭🇷" },
  "386": { name: "Slovenia", flag: "🇸🇮" },
  "387": { name: "Bosnia and Herzegovina", flag: "🇧🇦" },
  "389": { name: "North Macedonia", flag: "🇲🇰" },
  "420": { name: "Czech Republic", flag: "🇨🇿" },
  "421": { name: "Slovakia", flag: "🇸🇰" },
  "423": { name: "Liechtenstein", flag: "🇱🇮" },
  "500": { name: "Falkland Islands", flag: "🇫🇰" },
  "501": { name: "Belize", flag: "🇧🇿" },
  "502": { name: "Guatemala", flag: "🇬🇹" },
  "503": { name: "El Salvador", flag: "🇸🇻" },
  "504": { name: "Honduras", flag: "🇭🇳" },
  "505": { name: "Nicaragua", flag: "🇳🇮" },
  "506": { name: "Costa Rica", flag: "🇨🇷" },
  "507": { name: "Panama", flag: "🇵🇦" },
  "508": { name: "Saint Pierre and Miquelon", flag: "🇵🇲" },
  "509": { name: "Haiti", flag: "🇭🇹" },
  "590": { name: "Guadeloupe", flag: "🇬🇵" },
  "591": { name: "Bolivia", flag: "🇧🇴" },
  "592": { name: "Guyana", flag: "🇬🇾" },
  "593": { name: "Ecuador", flag: "🇪🇨" },
  "594": { name: "French Guiana", flag: "🇬🇫" },
  "595": { name: "Paraguay", flag: "🇵🇾" },
  "596": { name: "Martinique", flag: "🇲🇶" },
  "597": { name: "Suriname", flag: "🇸🇷" },
  "598": { name: "Uruguay", flag: "🇺🇾" },
  "599": { name: "Netherlands Antilles", flag: "🇧🇶" },
  "670": { name: "East Timor", flag: "🇹🇱" },
  "672": { name: "Norfolk Island", flag: "🇳🇫" },
  "673": { name: "Brunei", flag: "🇧🇳" },
  "674": { name: "Nauru", flag: "🇳🇷" },
  "675": { name: "Papua New Guinea", flag: "🇵🇬" },
  "676": { name: "Tonga", flag: "🇹🇴" },
  "677": { name: "Solomon Islands", flag: "🇸🇧" },
  "678": { name: "Vanuatu", flag: "🇻🇺" },
  "679": { name: "Fiji", flag: "🇫🇯" },
  "680": { name: "Palau", flag: "🇵🇼" },
  "681": { name: "Wallis and Futuna", flag: "🇼🇫" },
  "682": { name: "Cook Islands", flag: "🇨🇰" },
  "683": { name: "Niue", flag: "🇳🇺" },
  "685": { name: "Samoa", flag: "🇼🇸" },
  "686": { name: "Kiribati", flag: "🇰🇮" },
  "687": { name: "New Caledonia", flag: "🇳🇨" },
  "688": { name: "Tuvalu", flag: "🇹🇻" },
  "689": { name: "French Polynesia", flag: "🇵🇫" },
  "690": { name: "Tokelau", flag: "🇹🇰" },
  "691": { name: "Micronesia", flag: "🇫🇲" },
  "692": { name: "Marshall Islands", flag: "🇲🇭" },
  "850": { name: "North Korea", flag: "🇰🇵" },
  "852": { name: "Hong Kong", flag: "🇭🇰" },
  "853": { name: "Macau", flag: "🇲🇴" },
  "855": { name: "Cambodia", flag: "🇰🇭" },
  "856": { name: "Laos", flag: "🇱🇦" },
  "880": { name: "Bangladesh", flag: "🇧🇩" },
  "886": { name: "Taiwan", flag: "🇹🇼" },
  "960": { name: "Maldives", flag: "🇲🇻" },
  "961": { name: "Lebanon", flag: "🇱🇧" },
  "962": { name: "Jordan", flag: "🇯🇴" },
  "963": { name: "Syria", flag: "🇸🇾" },
  "964": { name: "Iraq", flag: "🇮🇶" },
  "965": { name: "Kuwait", flag: "🇰🇼" },
  "966": { name: "Saudi Arabia", flag: "🇸🇦" },
  "967": { name: "Yemen", flag: "🇾🇪" },
  "968": { name: "Oman", flag: "🇴🇲" },
  "970": { name: "Palestine", flag: "🇵🇸" },
  "971": { name: "United Arab Emirates", flag: "🇦🇪" },
  "972": { name: "Israel", flag: "🇮🇱" },
  "973": { name: "Bahrain", flag: "🇧🇭" },
  "974": { name: "Qatar", flag: "🇶🇦" },
  "975": { name: "Bhutan", flag: "🇧🇹" },
  "976": { name: "Mongolia", flag: "🇲🇳" },
  "977": { name: "Nepal", flag: "🇳🇵" },
  "992": { name: "Tajikistan", flag: "🇹🇯" },
  "993": { name: "Turkmenistan", flag: "🇹🇲" },
  "994": { name: "Azerbaijan", flag: "🇦🇿" },
  "995": { name: "Georgia", flag: "🇬🇪" },
  "996": { name: "Kyrgyzstan", flag: "🇰🇬" },
  "998": { name: "Uzbekistan", flag: "🇺🇿" },
}
